import cx from 'clsx';
import { FC, memo } from 'react';
import { DeviceStatusEnum } from 'src/api/device';
import { InteractionStatusEnum } from 'src/api/interactions';

import styles from './styles.module.css';

type Props = {
  status: DeviceStatusEnum | InteractionStatusEnum;
};

const statusName = {
  [DeviceStatusEnum.ONLINE]: 'online',
  [DeviceStatusEnum.OFFLINE]: 'offline',
  [DeviceStatusEnum.ERROR]: 'error',
  [DeviceStatusEnum.ACTIVE]: 'active',
  [DeviceStatusEnum.INACTIVE]: 'inactive',
  [DeviceStatusEnum.ORDERED]: 'ordered',
};

export const Status: FC<Props> = memo(({ status }) => {
  return (
    <div
      className={cx({
        [styles.status]: true,
        [styles.statusOnline]:
          status === DeviceStatusEnum.ONLINE ||
          status === DeviceStatusEnum.ACTIVE,
        [styles.statusOffline]:
          status === DeviceStatusEnum.OFFLINE ||
          status === DeviceStatusEnum.INACTIVE,
        [styles.statusError]: status === DeviceStatusEnum.ERROR,
      })}
    >
      <span className={styles.label}>{statusName[status]}</span>
    </div>
  );
});
